import { Fragment, type ReactNode } from "react";

/**
 * Масите на една сметка като едно име — „14 | 13 | 12": между тях тънка,
 * неудебелена черта в цвета на текста, приглушена. `renderName` — всяко име
 * по свой начин (картата в списъка оцветява търсеното).
 */
const JoinedTableNames = ({
  names,
  renderName = (name) => name,
}: {
  names: string[];
  renderName?: (name: string) => ReactNode;
}) => (
  <>
    {names.map((name, position) => (
      <Fragment key={position}>
        {position > 0 && <span className="mx-1.5 font-normal opacity-40">|</span>}
        {renderName(name)}
      </Fragment>
    ))}
  </>
);

export default JoinedTableNames;
